// extracted by mini-css-extract-plugin
module.exports = {"blue":"BlueButton_blue__GZ6IA"};